import React, { FC, ReactElement } from 'react'
import styles from './UtxoItem.module.css'
import WalletConfirmed from '@/app/wallet/wallet/wallet-confirmed'
import useExchangeRate from '@/utils/hooks/useExchangeRate'
import classNames from 'classnames'
import BitcoinIcon from '@/icons/bitcoin-filled'
import { MEMPOOL_DOT_SPACE } from '@/utils/constants'

const UtxoItem: FC<{ utxo: any; link?: boolean }> = (props): ReactElement => {
	const { link, utxo } = props
	const { exchangeRate } = useExchangeRate()

	const body = (
		<>
			<div className={styles.left}>
				<BitcoinIcon className={styles.icon} />
				<div className={styles.body}>
					<div className={classNames(styles.btc, 'text-md', 'bold')}>
						{(utxo.value / 1e8).toFixed(8)}
					</div>
					<div className={classNames(styles.usd, 'text-sm', 'regular')}>
						~${((utxo.value / 1e8) * exchangeRate).toFixed(2)}
					</div>
				</div>
			</div>
			<WalletConfirmed status={utxo.status.confirmed ? 'confirmed' : 'unconfirmed'} />
		</>
	)

	if (link) {
		return (
			<a
				target="_blank"
				href={`${MEMPOOL_DOT_SPACE}/tx/${utxo.txid}#vout=${utxo.vout}`}
				className={classNames(styles.root, styles.linkRoot)}
			>
				{body}
			</a>
		)
	}

	return <div className={styles.root}>{body}</div>
}

export default UtxoItem
